var _g, _g2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "9.08 5.14 51.92 51.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_588_5617)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.041,
    cy: 31.0995,
    r: 25.9589,
    fill: "black",
    fillOpacity: 0.94,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_588_5617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7689 40.0865C31.7689 40.4097 31.673 40.7256 31.4935 40.9943C31.314 41.2629 31.0588 41.4723 30.7603 41.596C30.4617 41.7197 30.1332 41.752 29.8163 41.689C29.4993 41.6259 29.2082 41.4703 28.9797 41.2418C28.7512 41.0133 28.5956 40.7222 28.5326 40.4053C28.4695 40.0884 28.5019 39.7598 28.6255 39.4613C28.7492 39.1628 28.9586 38.9076 29.2273 38.7281C29.496 38.5485 29.8119 38.4527 30.135 38.4527C30.5683 38.4527 30.9839 38.6248 31.2903 38.9312C31.5967 39.2376 31.7689 39.6532 31.7689 40.0865ZM40.755 38.4527C40.4318 38.4527 40.1159 38.5485 39.8473 38.7281C39.5786 38.9076 39.3692 39.1628 39.2455 39.4613C39.1218 39.7598 39.0895 40.0884 39.1525 40.4053C39.2156 40.7222 39.3712 41.0133 39.5997 41.2418C39.8282 41.4703 40.1193 41.6259 40.4362 41.689C40.7532 41.752 41.0817 41.7197 41.3802 41.596C41.6788 41.4723 41.9339 41.2629 42.1135 40.9943C42.293 40.7256 42.3888 40.4097 42.3888 40.0865C42.3888 39.6532 42.2167 39.2376 41.9103 38.9312C41.6039 38.6248 41.1883 38.4527 40.755 38.4527ZM45.4972 24.8969C45.4212 24.794 45.3221 24.7103 45.2079 24.6527C45.0937 24.595 44.9675 24.565 44.8396 24.5651H26.9L26.0719 21.665C25.973 21.3243 25.7665 21.0247 25.4832 20.8112C25.1999 20.5977 24.8551 20.4816 24.5003 20.4805H22.7827C22.5661 20.4805 22.3583 20.5665 22.2051 20.7197C22.0519 20.8729 21.9658 21.0807 21.9658 21.2974C21.9658 21.514 22.0519 21.7218 22.2051 21.875C22.3583 22.0282 22.5661 22.1143 22.7827 22.1143H24.5003L28.1948 35.041C28.3427 35.5521 28.6521 36.0016 29.0768 36.3221C29.5015 36.6426 30.0186 36.8169 30.5506 36.8189H40.3649C40.8894 36.8207 41.4006 36.6534 41.8226 36.3418C42.2445 36.0302 42.5548 35.5909 42.7074 35.089L45.6207 25.622C45.6583 25.4999 45.6666 25.3707 45.6452 25.2448C45.6237 25.1188 45.573 24.9997 45.4972 24.8969Z",
    fill: "#FFE227"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0562 27.8242L36.0562 33.8067",
    stroke: "#030201",
    strokeWidth: 1.80286,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0454 30.8164L33.0629 30.8164",
    stroke: "#030201",
    strokeWidth: 1.80286,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_588_5617",
    x: 0.841104,
    y: 0.196068,
    width: 68.3998,
    height: 68.3998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.29637
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.12046
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14902 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_5617"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_5617",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_588_5617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1414,
    height: 26.1414,
    fill: "white",
    transform: "translate(21.9678 18.0312)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetail);
export default __webpack_public_path__ + "static/media/view_detail.1971b331ae8c10bc60aa88989d200b57.svg";
export { ForwardRef as ReactComponent };